export enum ORDER_DOCUMENT_SOURCE {
  ERP = 1,
  MARKETPLACE,
  CLIENT,
  COURIER,
  STER
}
